<template>
    <ConfirmDialog />
  <div class="simple-layout-wrapper">
    <div class="simple-topbar">
      <img src="../assets/logo-text.png" alt="HARVEDEX Logo" class="simple-logo" />
    </div>
    <div class="simple-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import ConfirmDialog from 'primevue/confirmdialog'
// 无需特殊逻辑
</script>

<style scoped>
.simple-layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-width: 100vw;
}
.simple-topbar {
  height: 56px;
  background: #fff;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.03);
  border-bottom: 1px solid #EBEBEB;
  flex-shrink: 0;
}
.simple-logo {
  height: 32px;
}
.simple-content {
  flex: 1;
  background: #F9F9F9;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
</style> 